import {createFileRoute} from '@tanstack/react-router';
import Chat from '@features/prototype/[id]/page';
import './layout.css';

export const Route = createFileRoute('/prototype/$id')({
  component: function PrototypePage() {
    const {id} = Route.useParams();
    return (
      <div className='prototype-route'>
        <Chat id={id} />
        <title>Banani | Prototype</title>
      </div>
    );
  },
});
